// extracted by mini-css-extract-plugin
module.exports = {"container":"quize-free-answer_container__DGRXu","answer":"quize-free-answer_answer__1QvOg","student":"quize-free-answer_student__2V9Zu"};